<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="chat-square-text" class="mLeft"></b-icon>
            <div class="headerTxt mLeft">Notas PTI</div>
          </div>
          <div class="alignIcon bold">Notas_M2</div>
        </div>

        <div class="m-5">
          <b-list-group class="m-5" v-if="notas.length >0">
            <b-list-group-item class="flex-column align-items-start" v-for="(nota, index) in notas" :key="index">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-1" style="color: rgb(13, 90, 141)">{{ nota.usuario }}</h6>
                <small class="text-muted">{{ nota.fecha | formatoFechaHora }}</small>
              </div>
              <small class="text-muted">{{ nota.nota }}</small>
            </b-list-group-item>
          </b-list-group>
          <b-alert v-else show variant="warning">No se han registrado notas.</b-alert>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {NuevoM2Service} from "@/apiServices/pti/NuevoM2Service";

export default {
  name: "NotasPacientePTI",
  props: {
    idPti: String
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    notas: [],
    nuevoM2Service: new NuevoM2Service()
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  async mounted() {
      await this.obtenerNotasPti();
  },
  methods: {
    obtenerNotasPti(){
      this.nuevoM2Service.obtenerNotasPti(parseInt(this.idPti)).then((r) => {
        this.notas = r;
      })
    }
  }
}
</script>

<style scoped>

</style>
